const config = {
  title: 'Interview system',
  lable_username: 'Username',
  lable_psd: 'Password',
  lable_remeb_Me: 'rememeber me',
  forgot_psd: 'forget password',
  login_btn: 'Login',
  logSuccess: 'Login Success',
  logError: {
    200: 'Account not find or password incorrect',
    201: 'This account is locked, please contact your system administrator',
    0: 'System maintenance\nPlease try again later',
    104: 'Connection Timeout',
  },
  select_school: 'Please select a school',
  school_name: 'School Name',
  next_step: 'Next step',
  Traditional: 'Traditional Chinese',
  Simplified: 'Simplified Chinese'
};

export default config;
